import { put, takeEvery, call } from "redux-saga/effects";
import { getAppSKUsEval } from "../../../tools/cp-middleware-adapter";
import { normalizeError } from "../../../components/auth/Auth0Lock/helpers";
import * as actions from "./cpAppEvalSKUsPostActions";
import { ActionTypes, RequestAction, AppEvaluationData } from "./types";

function* cpAppEvalSKUsRequest(action: RequestAction) {
  try {
    const response: AppEvaluationData = yield call(getAppSKUsEval, action.app);

    yield put(actions.requestSuccess(response));
  } catch (error) {
    const normalizedError = normalizeError(error);
    yield put(actions.requestFailure(normalizedError.message));
  }
}

function* saga() {
  yield takeEvery(ActionTypes.CP_APP_EVAL_SKUS_REQUEST, cpAppEvalSKUsRequest);
}

export default saga;
